import Landing from "./Landing";
// eslint-disable-next-line no-unused-vars
import RequestDemo from "./RequestDemo"; // kept for the in-progress demo-request form, see RequestDemo.js

function App() {
  return (
    <div className="App">
        <Landing />
        {/* <RequestDemo /> */}
    </div>
  );
}

export default App;